import React, { useContext, useState } from "react";
/// React router dom
import { Routes, Route, Outlet } from "react-router-dom";
/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";

//Scroll To Top
import ScrollToTop from "./layouts/ScrollToTop";
import Student from "./pages/Students";
import Concept from "./pages/Concepts";
import Monthly from "./pages/Monthly";
import Annualy from "./pages/Annualy";
import Request from "./pages/Request";
import Admins from "./pages/Admins";
import Configuration from "./pages/Config";
import DegreeChange from "./pages/DegreeChange";
import Settlement from "./pages/Settlement";
import Nonpay from "./pages/Nonpay";
import Report from "./pages/Report";

import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Markup = () => {

  const allroutes = [
    { url: "", component: <Student /> },
    { url: "students", component: <Student /> },
    { url: "request", component: <Request /> },
    { url: "concepts", component: <Concept /> },
    { url: "monthly", component: <Monthly /> },
    { url: "annualy", component: <Annualy /> },
    { url: "config", component: <Configuration /> },
    { url: "users", component: <Admins /> },
    { url: "degreechange", component: <DegreeChange /> },
    { url: "nonpay", component: <Nonpay /> },
    { url: "settlement/:id/:year?", component: <Settlement /> },
    { url: "report", component: <Report /> },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  return (
    <div id="main-wrapper" className={`show `}>
      <Nav />
      <div
        className="content-body"
        style={{ minHeight: window.screen.height - 45 }}
      >
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <ToastContainer />
      <Footer />
    </div>
  );
}

export default Markup;
